"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M3 18.5a.5.5 0 0 0 .5.5h2.6a.5.5 0 0 0 .5-.5V9.722a.5.5 0 0 0-.5-.5H3.5a.5.5 0 0 0-.5.5V18.5zm17.896-8.184a1 1 0 0 0-.995-1.094H13.8l1.09-2.87a4 4 0 0 0 .26-1.42v-.154c0-.239-.121-.958-.273-1.414-.082-.248-.323-.364-.585-.364h-.056a1 1 0 0 0-.733.32L8.85 8.333c-.303.288-.483.45-.483.89v8.888c0 .88.033.889.933.889h9.805a1 1 0 0 0 .994-.89l.401-3.61.396-4.184z" }), "Like");
//# sourceMappingURL=Like.js.map